import { IMlReview } from '../../types/newbuilding/reviews';
import { TApplicationState } from '../../types/redux';

export const getMlReviews = (state: TApplicationState): IMlReview | null => {
  return state.newbuilding.reviews?.mlReview || null;
};
